export default async ({ $api, store }) => {
  await $api('util/motor_insurers').then(providers => store.commit('providers/setList', providers));
};
